(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('webpageSettingMenu', {
        templateUrl: 'views/components/views/webpageSettingMenu/webpageSettingMenu.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'utilityService', 'userService', 'webpageSettingMenuService', 'translateService', 'p2WebpageService', function ($stateParams, utilityService, userService, webpageSettingMenuService, translateService, p2WebpageService) {
            const vm = this;
            let webPageName = $stateParams.webpage_name;
            let canHideShowLayoutSetting = false;
            var slc;
            var slcIndex;

            let translations = {
                showHideLayoutControls: ''
            };

            vm.model = {
                itemsListWebPageSettings: []
            };
            
            async function load() {
                let promises = [];
                
                promises.push(webpageSettingMenuService.listWebPageSettings({ webpage_name: webPageName }));
                
                if (canHideShowLayoutSetting) promises.push(p2WebpageService.details(webPageName));

                return Promise.all(promises).then(function (response) {
                    if (canHideShowLayoutSetting) {
                        slc = utilityService.toBoolean(response[1].show_layout_controls);
                        
                        response[0].push({
                            item_id: '1000',
                            item_name: translations.showHideLayoutControls,
                            item_glyphicon: slc ? 'glyphicon-check' : 'glyphicon-unchecked',
                            item_glyphicon_color: slc ? 'green' : 'red',
                            orderby: 1000,
                            item_state: 'customaction',
                            item_parms: '',
                            item_action: function () {
                                slc = !slc;
                                
                                p2WebpageService.toogleShowLayoutControls(webPageName).then(function () {
                                    vm.model.itemsListWebPageSettings[slcIndex].item_glyphicon = slc ? 'glyphicon-check' : 'glyphicon-unchecked';
                                    vm.model.itemsListWebPageSettings[slcIndex].item_glyphicon_color = slc ? 'green' : 'red';
                                });
                            }
                        });
                        
                        slcIndex = response[0].length - 1;
                    }
                    
                    vm.model.itemsListWebPageSettings = response[0];
                });
            }
            
            const deregTranslations = translateService.on(translations, 'changed', function (result) {
                deregTranslations();
                
                translations = result;

                userService.ensureIsReady().then(function () {
                    canHideShowLayoutSetting = utilityService.toBoolean(userService.userSettings['_240'].value); // setting_show_gui_layout_controls
                    
                    load();
                });
            });
        }]
    });
})();
